<template>
  <el-dialog title="关联小区" :visible.sync="dialogTableVisible" width="1200px">
    <el-table :data="list">
      <el-table-column prop="refResidentialAreaNumber" label="小区编号"></el-table-column>
      <el-table-column prop="refResidentailAreaName" label="小区名称"></el-table-column>
      <el-table-column label="关联时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | timeFormate }}
        </template>
      </el-table-column>
      <el-table-column label="网点">
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.storeList" :key="index">
            {{ `${item.name}；` }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialogTableVisible: false,
      defaultParams: {},
      list: []
    }
  },
  methods: {
    open(row) {
      this.list = row.residentialAreaBeanList
      this.dialogTableVisible = true
    },
  }
}
</script>

<style lang="scss" scoped></style>
